import DatePicker from 'vue2-datepicker'
import apiUrl from '../../../constants'
import axios from 'axios'
import moment from 'moment'
import CryptoJS from 'crypto-js';
import Loader from './../shared/loader'
import Pagination from './../shared/pagination'
import Vue from "vue";
import { BasicSelect } from 'vue-search-select'
import download from 'downloadjs';
import csvHelper from '../reports/importjsontocsv';
import {
	Validator
} from 'vee-validate'
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);


export default{
    name:"inventoryReconciliation",
    components:{
        DatePicker,
        Loader,
        BasicSelect,
        Pagination,
        JsonExcel,
        download
    },
    data(){
     return{
        client:'',
        clientid:'',
        warehouse:'',
        warehouseid:'',
        text:'',
        skuInputString:'',
        skuList:[],
        daterangeradiobutton:'custom',
        stocktype:'',
        stocktypeErr:'',
        stockbasis:'CS',
        isLoading:false,
        formattedDate: '',
        totalRows:0,
        isLoadingforxls: false,
        download:true,
        show:false,
        limitExeed: false,
        searchFlag: false,
        inventoryReconciliationReportData:[],
        inventoryReconciliationReportDatacsv:[],
        inventoryReconciliationReportDataXls:[],
        resultCount:0,
        currentPage:1,
        pageLimit:10,
        fromdate:'',
        csvFields: [],
        csvFieldsForXls:{},
        totalPage:0,
        dataFilter2:'',
        reportName:'',
        recordLimit:0
     }
    },
    computed :{

    },
    filters: {
		moment: function (date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},
	},
    mounted(){
        this.calldateFunction();
        let permissionEncrypt = window.localStorage.getItem('userdetail');
		let bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		let plaintext = bytes.toString(CryptoJS.enc.Utf8);
		let userdetail = JSON.parse(plaintext);
		this.createdbyEmail = userdetail.email;
		this.userid = userdetail.userid;
		let today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss');
        this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
        this.user_type = userdetail.utype
        this.reportName=this.$t('inventoryReconciliationReport.inventoryreconciliationreport')+moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
        switch (this.user_type) {
			case 'system_user':
				this.checkclient()
				this.checkwarehouse()
				break

			case 'client_user':
				this.checkwarehouse()
				break

			case 'warehouse_user':
				this.checkclient()
				break

			default:
				this.$alert("Unauthorised user, Please contact your system admin")
				break
		}
        this.getRecordLimit();
        this.$root.$on('localStorageChanged', (newValue) => {
			// Update your local data
			this.warehouse = newValue;
            this.warehouseid=this.warehouse;
		  });
    },
    methods:{
        calldateFunction: function () {
			this.currentDate = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
			var dt= new Date(this.currentDate);
            dt.setDate(dt.getDate()-6);
            this.fromdate=dt;
        },
        startDownload() {
			this.isLoadingforxls = true;
		},
        finishDownload() {
			this.isLoadingforxls = false;
		},
        export(data, filename, mime) {
            let blob = this.base64ToBlob(data, mime)
            download(blob, filename, mime)
        },
        base64ToBlob(data, mime) {
            let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
            let bstr = atob(base64)
            let n = bstr.length
            let u8arr = new Uint8ClampedArray(n)
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n)
            }
            return new Blob([u8arr], {
                type: mime
            })
        },
        getRecordLimit() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({

			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getRecordLimit',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data) {
						this.recordLimit = result.data.data;


					}
				}, error => {
					console.error(error)
				})
		},
        checkclient(){
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") == '')
			{
				this.$alertify.error(this.$t('common.clientError'))
                this.inventoryReconciliationReportData = [];
				this.isLoading = false
				return false
			}
		},
		checkwarehouse(){
			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse") == '')
			{
				this.$alertify.error(this.$t('common.warehouseError'))
                this.inventoryReconciliationReportData = [];
				this.isLoading = false
				return false
			}
		},
        validateInput(event) {
            const regex = /^[#_\/\-\w\n,]*$/;
            if(regex.test(this.text)){
                this.skuInputString=event.target.value;
            }else{
                this.$alertify.error(this.$t('unicommerce.importUniwareProduct.invalidInput'))
            }
        },
        convertSkuStringToArray(){
            if(this.skuInputString==''){
              this.skuList=[];
              return 
            }
            if(this.skuInputString.includes(',')){
              this.skuList=this.skuInputString.split(',').map(item => item.trim()).filter(item => item !== '');
            }else{
              this.skuList=this.skuInputString.split('\n').map(item => item.trim()).filter(item => item !== '');
            }
          },
        onChangeHandler(event) {
            this.validateInput(event);
          },
          Choosetype() {
			this.show = true;
			this.download = false;
			if (!this.limitExeed) {
				this.getInventoryReconciliationReportDataForXls(3)
            }
		},
        getStockAdjustment(data){
            return (Number(data.auditqtyplus)+Number(data.receiptqty))
        },
        getStockCorrection(data){
           return (Number(data.auditqtydeduct)+Number(data.issueqty))
        },
        getAccountedQty(data){
          let inQty=Number(data.poputawayqty)+Number(data.cancelputawayqty)+Number(data.rtoputawayqty)+Number(data.srputawayqty)+Number(data.auditqtyplus)+Number(data.receiptqty)
          let outQty=(Number(data.shipqty)-Number(data.cancelqty))+Number(data.auditqtydeduct)+Number(data.issueqty)
          return Number(data.fromdatestock)+inQty-outQty 
        },
        getAllocatedQty(data){
            return (Number(data.shipqty)- Number(data.cancelqty))
        },
        getDifferenceQty(data){
            let inQty=Number(data.poputawayqty)+Number(data.cancelputawayqty)+Number(data.rtoputawayqty)+Number(data.srputawayqty)+Number(data.auditqtyplus)+Number(data.receiptqty)
            let outQty=(Number(data.shipqty)-Number(data.cancelqty))+Number(data.auditqtydeduct)+Number(data.issueqty)
            let accountedQty=Number(data.fromdatestock)+inQty-outQty 
            return Number(data.systemstock)-accountedQty
        },
          getInventoryReconciliationReportsearch(){
            this.convertSkuStringToArray();
            this.currentPage=1;
            this.searchFlag = true;
            this.getInventoryReconciliationReportData(2);
          },
         async getInventoryReconciliationReportData(csvCheck = 0){
            let userToken = window.localStorage.getItem('userToken');
			let myStr = userToken.replace(/"/g, '');
            let fr_date=''
            var dataFilter = {};
            if (csvCheck == 2) {
				this.show = false;
				this.download = true;
				this.limitExeed = false;
			}

            if (this.fromdate == '') {
				fr_date = '';
			} else {
				fr_date = this.dateFormat(this.fromdate, 0);
			}

            if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") == '')
            {
                    this.$alertify.error(this.$t('common.clientError'))
                    this.inventoryReconciliationReportData = [];
                    return false
            }
            if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse") == '')
            {
                    this.$alertify.error(this.$t('common.warehouseError'))
                    this.inventoryReconciliationReportData = [];
                    return false
            }

            if(this.skuList.length==0){
                this.$alertify.error(this.$t('inventoryReconciliationReport.clientProductError'));
                this.inventoryReconciliationReportData = [];
                this.totalRows = 0;
                this.resultCount=0;
				return false;
            }
            if(this.skuList.length>100){
                this.$alertify.error(this.$t('inventoryReconciliationReport.clientProductLimit'));
                this.inventoryReconciliationReportData = [];
                this.totalRows = 0;
                this.resultCount=0;
                return false
            }
            let uniqueSku = new Set(this.skuList);
            if (uniqueSku.size !== this.skuList.length) {
                this.$alertify.error(this.$t('inventoryReconciliationReport.clientProductDuplicate'))
                this.totalRows = 0;
                this.resultCount=0;
                this.inventoryReconciliationReportData=[];
                return false;
            }

            if((this.fromdate==''||this.fromdate==null)&& this.daterangeradiobutton=='custom'){
                this.$alertify.error(this.$t('inventoryReconciliationReport.DateFieldErr'));
                this.inventoryReconciliationReportData = [];
                this.totalRows = 0;
                this.resultCount=0;
				return false;
            }
            if(this.stocktype==''){
                this.stocktypeErr=this.$t('inventoryReconciliationReport.stockTypeErr');
                this.inventoryReconciliationReportData = [];
                this.totalRows = 0;
                this.resultCount=0;
				return false;
            }

			this.isLoading = true;
            this.input=({
                clientid:this.clientid,
                warehouseid:this.warehouseid,
                skuList:this.skuList,
                fromdate:fr_date,
                stocktype:this.stocktype,
                stockbasis:this.stockbasis,
                offset:(this.currentPage - 1) * 10,
                limit:this.pageLimit,
                csvData:csvCheck
            });
            if(this.daterangeradiobutton=='start'){
                this.input.fromdate=''
            }
            Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
            const result=  await axios({
                    method:'POST',
                    'url': apiUrl.api_url + 'inventoryReconciliationReport',
                    'data': this.input,
                    headers: {
                        'Authorization': 'Bearer ' + myStr
                    }
                })
            try{
                if (csvCheck == 1) {
                    if (result.data.data.length > 0) {
                        this.show = true;
                        this.download = false;
                        this.inventoryReconciliationReportDatacsv = [];
                        this.csvFields = {
                            'clientproductid':  this.$t('product.clientProductId'),
                            'eancode':  this.$t('inwardList.printData.productDetails.eanCode'),
                            'firsttxndate':this.$t('inventoryReconciliationReport.firstdate'),
                            'fromdate': this.$t('inventoryReconciliationReport.fromdate'),
                            'todate': this.$t('inventoryReconciliationReport.todate'),
                            'fromdatestock': this.$t('inventoryReconciliationReport.fromdatestock'),
                            'poputawayqty': this.$t('inventoryReconciliationReport.poputawayqty'),
                            'cancelputawayqty': this.$t('inventoryReconciliationReport.cancelputawayqty'),
                            'rtoputawayqty': this.$t('inventoryReconciliationReport.rtoputawayqty'),
                            'srputawayqty': this.$t('inventoryReconciliationReport.srputawayqty'),
                            'stockadjustmentqty': this.$t('inventoryReconciliationReport.stockadjustment'),
                            'shipqty': this.$t('inventoryReconciliationReport.shippedqty'),
                            'stockcorrectionqty':this.$t('inventoryReconciliationReport.stockcorrection'),
                            'accountedqty':this.$t('inventoryReconciliationReport.accountedqty'),
                            'systemstock':this.$t('inventoryReconciliationReport.systemqty'),
                            'diffqty':this.$t('inventoryReconciliationReport.difference')
                        };
                        var dateFilter=[];
                        var skipFilter=['count','productid']
                        var resultArray=result.data.data 
                        for(let i=0;i<resultArray.length;i++){
                            let eachInventoryData={}
                            eachInventoryData['clientproductid']=resultArray[i].clientproductid
                            eachInventoryData['eancode']=resultArray[i].eancode 
                            eachInventoryData['firsttxndate']=resultArray[i].firsttxndate
                            eachInventoryData['fromdate']=resultArray[i].fromdate 
                            eachInventoryData['todate']=resultArray[i].todate
                            eachInventoryData['fromdatestock']=Number(resultArray[i].fromdatestock)
                            eachInventoryData['poputawayqty']=Number(resultArray[i].poputawayqty)
                            eachInventoryData['cancelputawayqty']=Number(resultArray[i].cancelputawayqty)
                            eachInventoryData['rtoputawayqty']=Number(resultArray[i].rtoputawayqty)
                            eachInventoryData['srputawayqty']=Number(resultArray[i].srputawayqty)
                            eachInventoryData['stockadjustmentqty']=this.getStockAdjustment(resultArray[i])
                            eachInventoryData['shipqty']=this.getAllocatedQty(resultArray[i])
                            eachInventoryData['stockcorrectionqty']=this.getStockCorrection(resultArray[i])
                            eachInventoryData['accountedqty']=this.getAccountedQty(resultArray[i])
                            eachInventoryData['systemstock']=Number(resultArray[i].systemstock)
                            eachInventoryData['diffqty']=this.getDifferenceQty(resultArray[i])
                            this.inventoryReconciliationReportDatacsv.push(eachInventoryData)
                        }
                        csvHelper.data.jsonToCSV(this.$t('inventoryReconciliationReport.inventoryreconciliationreport'), this.inventoryReconciliationReportDatacsv, this.csvFields,dateFilter, skipFilter, dataFilter);

                    } else {
                        if (result.data.status == true) {
                            this.$alertify.success(this.$t('common.reportSizeError'));
                        } else {
                            this.$alertify.error(result.data.msg);
                        }
                    }
                } else {
                    this.inventoryReconciliationReportData=[];
                    if (result.data.errorCode == -1) {
                        this.$alertify.error(result.data.msg);
                        this.resultCount = 0;
                        this.totalRows = 0;
                    } else {
                        this.totalRows = Number(result.data.count);
                        if (Number(this.totalRows) > Number(this.recordLimit)) {
                            this.limitExeed = true
                        }
                        this.resultCount = result.data.count;

                        if (result.data.data)
                            this.inventoryReconciliationReportData = result.data.data;

                        if (this.totalRows <= this.pageLimit) {
                            this.totalPage = 1;
                        } else {
                            this.totalPage = Math.ceil(this.totalRows / this.pageLimit);
                        }
                    }
                }
                this.isLoading = false;
            }catch(error){
               console.error(error)
            }
          },
        async  getInventoryReconciliationReportDataForXls(csvCheck=0){
            let userToken = window.localStorage.getItem('userToken');
			let myStr = userToken.replace(/"/g, '');
            let fr_date=''
            this.show = true;
			this.download = false;
			this.dataFilter2 = [];
            var value = '';
			var str = '';
            if (csvCheck == 2)
				this.pageno = 0;

            if (this.fromdate == '') {
				fr_date = '';
			} else {
				fr_date = this.dateFormat(this.fromdate, 0);
			}
            this.isLoading = true;
            this.input=({
                clientid:this.clientid,
                warehouseid:this.warehouseid,
                skuList:this.skuList,
                fromdate:fr_date,
                stocktype:this.stocktype,
                stockbasis:this.stockbasis,
                offset:(this.currentPage - 1) * 10,
                limit:this.pageLimit,
                csvData:csvCheck
            });
            if(this.daterangeradiobutton=='start'){
                this.input.fromdate=''
            }
            Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);

				}
			})

            const result=  await axios({
                method:'POST',
                'url': apiUrl.api_url + 'inventoryReconciliationReport',
                'data': this.input,
                headers: {
                    'Authorization': 'Bearer ' + myStr
                }
            })
            try{
                if(csvCheck==3){
                    if(result.data.data.length>0){
                       this.csvFieldsForXls={};
                       this.inventoryReconciliationReportDataXls=[];
                       this.csvFieldsForXls[this.$t('product.clientProductId')]='clientproductid'
                       this.csvFieldsForXls[this.$t('inwardList.printData.productDetails.eanCode')]='eancode'
                       this.csvFieldsForXls[this.$t('inventoryReconciliationReport.firstdate')]='firsttxndate'
                       this.csvFieldsForXls[this.$t('inventoryReconciliationReport.fromdate')]='fromdate'
                       this.csvFieldsForXls[this.$t('inventoryReconciliationReport.todate')]='todate'
                       this.csvFieldsForXls[this.$t('inventoryReconciliationReport.fromdatestock')]='fromdatestock'
                       this.csvFieldsForXls[this.$t('inventoryReconciliationReport.poputawayqty')]='poputawayqty'
                       this.csvFieldsForXls[this.$t('inventoryReconciliationReport.cancelputawayqty')]='cancelputawayqty'
                       this.csvFieldsForXls[this.$t('inventoryReconciliationReport.rtoputawayqty')]='rtoputawayqty'
                       this.csvFieldsForXls[this.$t('inventoryReconciliationReport.srputawayqty')]='srputawayqty'
                       this.csvFieldsForXls[this.$t('inventoryReconciliationReport.stockadjustment')]='stockadjustmentqty'
                       this.csvFieldsForXls[this.$t('inventoryReconciliationReport.shippedqty')]='shipqty'
                       this.csvFieldsForXls[this.$t('inventoryReconciliationReport.stockcorrection')]='stockcorrectionqty'
                       this.csvFieldsForXls[this.$t('inventoryReconciliationReport.accountedqty')]='accountedqty'
                       this.csvFieldsForXls[this.$t('inventoryReconciliationReport.systemqty')]='systemstock'
                       this.csvFieldsForXls[this.$t('inventoryReconciliationReport.difference')]='diffqty'



                       var resultArray=result.data.data 
                       await resultArray.map(eachData=>{
                            let eachInventoryData={}
                            eachInventoryData['clientproductid']=eachData.clientproductid
                            eachInventoryData['eancode']=eachData.eancode 
                            eachInventoryData['firsttxndate']=eachData.firsttxndate
                            eachInventoryData['fromdate']=eachData.fromdate 
                            eachInventoryData['todate']=eachData.todate
                            eachInventoryData['fromdatestock']=Number(eachData.fromdatestock)
                            eachInventoryData['poputawayqty']=Number(eachData.poputawayqty)
                            eachInventoryData['cancelputawayqty']=Number(eachData.cancelputawayqty)
                            eachInventoryData['rtoputawayqty']=Number(eachData.rtoputawayqty)
                            eachInventoryData['srputawayqty']=Number(eachData.srputawayqty)
                            eachInventoryData['stockadjustmentqty']=this.getStockAdjustment(eachData)
                            eachInventoryData['shipqty']=this.getAllocatedQty(eachData)
                            eachInventoryData['stockcorrectionqty']=this.getStockCorrection(eachData)
                            eachInventoryData['accountedqty']=this.getAccountedQty(eachData)
                            eachInventoryData['systemstock']=Number(eachData.systemstock)
                            eachInventoryData['diffqty']=this.getDifferenceQty(eachData)
                            this.inventoryReconciliationReportDataXls.push(eachInventoryData)
                        })
                    }
                    else {
                        if (result.data.status == true) {
                            this.$alertify.success(this.$t('common.reportSizeError'));
                        } else {
                            this.$alertify.error(result.data.msg);
                        }
                    }
                }
                this.isLoading = false;
            }catch(error){
                console.error(error);
            }

          },
          onPageChange(page) {
			this.currentPage = page;
			this.getInventoryReconciliationReportData()
		},
        dateFormat(date, toFrom) {
			if (!toFrom)
				toFrom = '00:00:00'
			if (!date)
				return '';
			return moment(date).format('YYYY-MM-DD ' + toFrom);
		},
        resetForm(){
            this.text='';
            this.daterangeradiobutton='custom';
            this.stocktype='';
            this.stockbasis='CS';
            this.fromdate='';
            this.pageno = 0;
			this.totalRows = 0;
            this.inventoryReconciliationReportData=[];  
            this.skuInputString=''
            this.skuList=''
            this.resultCount=0
            this.show = false;
			this.download = true;
        }
    }
}


// WEBPACK FOOTER //
// ./src/views/components/inventoryReconciliation/inventoryReconciliation.component.js